import React, { FC, useEffect, useRef, useState, memo } from 'react';
import { timeActionConfig } from '../../_config/constant';
import { TimeBasicType } from '../../types';
import { throttle } from 'lodash-es';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { useIntl, getLocale } from 'umi';

import './index.scss';

interface TimeStandardActionProps {
  timeStandard: TimeBasicType;
  isAlignAcross: boolean;
}

const TimeStandardAction: FC<TimeStandardActionProps> = (props) => {
  const { timeStandard, isAlignAcross } = props;
  const [isFirst, setIsFirst] = useState(true);
  const [isActionEnd, setIsActonEnd] = useState(true);
  const earliestProgress = useRef<HTMLDivElement>(null);
  const earliestContainer = useRef<HTMLDivElement>(null);
  const [timerOut, setTimer] = useState<any>(null);
  const [intervalTimer, setIntervalTimer] = useState<any>(null);

  const { formatMessage } = useIntl()
  const locale = getLocale();
  useEffect(() => {
    handleDateProgress(timeStandard);
  }, [timeStandard]);

  const handleDateProgress = (timeStandard: TimeBasicType) => {
    if (timerOut) {
      clearTimeout(timerOut);
      setTimer(null);
    }

    if (intervalTimer) {
      clearInterval(intervalTimer);
      setIntervalTimer(null);
    }
    const containerWidth = earliestContainer?.current?.clientWidth || 0;
    const pcProgress = document.getElementById('pcProgress');
    const consoleProgress = document.getElementById('consoleProgress');
    const consoleTriangleNew = document.getElementById('consoleTriangle');
    const consoleProgressActionNew = document.getElementById(
      'consoleProgressAction',
    );

    // 蓝色长条定位小块
    const pcFrontBlock = document.getElementById('pcFrontBlock');
    const consoleFrontBlock = document.getElementById('consoleFrontBlock');

    // pc进度条位置重置
    if (pcProgress) {
      pcProgress.style.width = '0px';
      // 起点位置
      pcProgress.style.left =
        timeActionConfig?.[timeStandard]?.pc?.process || '10%';
      // 蓝色长条定位小块动画又css实现
      pcFrontBlock?.setAttribute('class', 'blue-block-front');
    }
    // console 进度条位置重置
    if (consoleProgress) {
      consoleProgress.style.width = '0px';
      // 起点位置
      consoleProgress.style.left =
        timeActionConfig?.[timeStandard]?.console?.process || '10%';
      // console 进度条如果出现左移动情况需要重置
      if (consoleTriangleNew && consoleProgressActionNew) {
        consoleProgressActionNew.style.marginLeft = '0px';
        consoleTriangleNew.style.marginRight = '0px';
      }

      consoleFrontBlock?.setAttribute('class', 'blue-block-front');
    }
    let num = 0;
    const timer = setTimeout(() => {
      setIsActonEnd(false);
      const proposesINterval = setInterval(() => {
        const pcProgressNew = document.getElementById('pcProgress');
        const consoleProgressNew = document.getElementById('consoleProgress');
        const consoleProgressAction = document.getElementById(
          'consoleProgressAction',
        );
        const consoleTriangle = document.getElementById('consoleTriangle');
        const earliestContainerId =
          document.getElementById('earliestContainer');
        const pcWidth = pcProgressNew?.clientWidth || 0;
        const earliestContainerWidth = earliestContainerId?.clientWidth || 0;
        let ratio = 0;
        if (earliestContainerId) {
          ratio = pcWidth / earliestContainerWidth;
        }
        if (ratio > 0.46) {
          // console version 点击Align across PC & Console version开关必定会出现移动情况
          if (isAlignAcross) {
            // if (isAlignAcross) {
            // 开关打开向左移动
            if (consoleProgressAction && consoleTriangle) {
              // 向左移动5% 需要50次
              if (num === 0.05 / 0.001 + 1) {
                clearInterval(proposesINterval);
                clearTimeout(timer);
                setIsActonEnd(true);
              } else {
                consoleProgressAction.style.marginLeft = `-${
                  0.001 * num * containerWidth
                }px`;
                consoleTriangle.style.marginRight = `${
                  0.001 * num * containerWidth
                }px`;
              }
            }
            num++;
          } else {
            // 动画全部展示完毕，清除定时器
            clearInterval(proposesINterval);
            clearTimeout(timer);
            setIsActonEnd(true);
          }
        } else {
          if (pcProgressNew) {
            // pc进度条动画 根据比例计算宽度
            pcProgressNew.style.width = `${
              (ratio + 0.015) * earliestContainerWidth
            }px`;
          }
          if (consoleProgressNew) {
            // console进度条动画
            consoleProgressNew.style.width = `${
              (ratio + 0.015) * earliestContainerWidth
            }px`;
          }
        }
      }, 20);
      setIntervalTimer(proposesINterval);
      setIsFirst(false);
    }, 2000);
    setTimer(timer);
  };

  const handleResize = throttle(() => {
    if (isActionEnd) {
      const pcProgress = document.getElementById('pcProgress');
      const consoleProgress = document.getElementById('consoleProgress');
      const earliestDom = document.getElementById('earliestContainer');
      const width = earliestDom?.clientWidth || 0;
      if (pcProgress) {
        pcProgress.style.width = `${width * 0.4723}px`;
      }

      if (consoleProgress) {
        consoleProgress.style.width = `${width * 0.4723}px`;
      }
    }
  }, 200);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isActionEnd]);

  return (
    <div className="benchmark-timestandard">
      <div className="benchmark-timestandard-title">
        {formatMessage({id: 'dbi_benchmark_definition_selection'})}
      </div>
      <div className="pc-version benchmark-timestandard-info">
        <span className="label" style={{ width: locale === LANGUAGE_CN? 128: 160 }}>
          {formatMessage({id: 'dbi_benchmark_pc_version'})}
        </span>
        <span className="action-container">
          <span
            className="progress"
            ref={earliestContainer}
            id="earliestContainer"
          >
            {/* 蓝色进度条 */}
            <span className="blue-block" ref={earliestProgress} id="pcProgress">
              <span id="pcFrontBlock"></span>
            </span>
            {/* 前定位块 */}
            <span className="slider-block" style={{ left: '10%' }}>
              <span className="earliest block"></span>
              <span className="block-title-earliest">
                {formatMessage({id: 'dbi_benchmark_earliest_data_date'})}
              </span>
            </span>
            {/* 后定位块 */}
            <span className="slider-block" style={{ left: '45%' }}>
              <span className="release block"></span>
              <span className="block-title-release">
                {formatMessage({id: 'dbi_benchmark_release_date'})}
              </span>
            </span>
          </span>
          <span className="triangle"></span>
        </span>
      </div>
      <div className="console-version benchmark-timestandard-info">
        <span className="label" style={{ width: locale === LANGUAGE_CN? 128: 160 }}>
          {formatMessage({id: 'dbi_benchmark_console_version'})}
        </span>
        <span className="action-container console-action">
          <span className="progress" id="consoleProgressAction">
            <span className="blue-block" id="consoleProgress">
              <span className="" id="consoleFrontBlock"></span>
            </span>
            <span className="slider-block" style={{ left: '15%' }}>
              <span className="earliest block"></span>
              <span className="block-title-earliest">
                {formatMessage({id: 'dbi_benchmark_earliest_data_date'})}
              </span>
            </span>
            <span className="slider-block" style={{ left: '50%' }}>
              <span className="release block"></span>
              <span className="block-title-release">
                {formatMessage({id: 'dbi_benchmark_release_date'})}
              </span>
            </span>
          </span>
          <span className="triangle" id="consoleTriangle"></span>
        </span>
      </div>
    </div>
  );
};

export default memo(TimeStandardAction);
